exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#retention {\n  width: 200px; }\n\n.apply-policy-dialog .form-group label.tooltip {\n  padding-left: 44px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/dataprotection/dataprotection-vc/apply-policy/apply-policy.scss
// module id = KDFX
// module chunks = 0